import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import DesignCard from "../components/DesignCard";
import { formatTypology } from "../lib/format";

const TYPOLOGY_ORDER = ["single_family", "adu", "duplex", "cottage_missing_middle"];

export default function Registry() {
  const [designs, setDesigns] = useState(null);
  useEffect(() => {
    api.get("/marketplace/designs").then((r) => setDesigns(r.data));
  }, []);

  if (!designs) {
    return <div style={{ color: "#6C6B85", fontStyle: "italic" }}>Loading registry…</div>;
  }

  const groups = TYPOLOGY_ORDER.map((t) => ({
    typology: t,
    items: designs.filter((d) => d.typology === t),
  })).filter((g) => g.items.length > 0);

  return (
    <section className="animate-fade-in-up" data-testid="registry-page">
      <div className="flex items-center gap-3">
        <span aria-hidden style={{ display: "inline-block", width: 28, height: 2, background: "#B14E2F" }} />
        <span className="wn-label" style={{ color: "#8F3C23" }}>Design registry</span>
      </div>
      <h1
        className="mt-4"
        style={{ fontSize: "clamp(34px, 4.6vw, 44px)", fontWeight: 500, lineHeight: 1.1 }}
      >
        Browse by typology.
      </h1>
      <p className="mt-3" style={{ color: "#6C6B85", fontSize: 15, maxWidth: 640, lineHeight: 1.55 }}>
        An editorial cut of the catalog, grouped by typology. Same approved
        designs, organised by what they are.
      </p>

      <div className="mt-6">
        <Link
          to="/marketplace"
          className="wn-btn wn-btn-tertiary"
          style={{ height: "auto", padding: 0 }}
          data-testid="back-to-marketplace"
        >
          ← Back to filters
        </Link>
      </div>

      <div style={{ borderTop: "1px solid #D9D8E4", marginTop: 24, marginBottom: 16 }} />

      {groups.map((g) => (
        <section key={g.typology} className="mt-10" data-testid={`registry-group-${g.typology}`}>
          <div className="flex items-baseline gap-3">
            <h2
              style={{
                fontFamily: '"Fraunces", Georgia, serif',
                fontWeight: 600,
                fontSize: 28,
                color: "#1B1F4B",
              }}
            >
              {formatTypology(g.typology)}
            </h2>
            <span className="tnum" style={{ color: "#6C6B85", fontSize: 14 }}>
              · {g.items.length}
            </span>
          </div>
          <div className="mt-5 grid md:grid-cols-2 lg:grid-cols-3 gap-[26px]">
            {g.items.map((d) => (
              <DesignCard key={d.id} design={d} />
            ))}
          </div>
        </section>
      ))}
    </section>
  );
}
